import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  ComponentFactoryResolver,
  EventEmitter,
  Injectable,
  Input,
  OnDestroy,
  OnInit,
  Output,
  Pipe,
  PipeTransform,
  TemplateRef,
  ViewChild,
  ViewContainerRef
} from "@angular/core";

import {CdkPortalOutlet} from "@angular/cdk/portal";

import {AppService} from '@core/services/app.service';
import {UserService} from '@core/services/user.service';
import {GOOGLE_SHEET_OPEN_MODAL_IMPORT} from '@shared/models/business';
import {ILanguageCodes, INavTabDataGird} from '@core/models';
import {ImgCdnPipe} from '@shared/pipes/global';
import {TranslocoService} from '@jsverse/transloco';
import {ImportExcelService} from '@shared/services/global';
import {EXCEL_URI_FILES_EXAMPLE, ExcelUriFilesExpLinks} from '@shared/constants';
import {ExcelDataAbstractService, ITabRefExportDataSetting} from '@shared/components/excel';
import {
  IConfigImportDataGoogleSheet,
  IImportDataHandlersAbstract,
  IOptionsImportDataExcelSetting,
  IParamsCheckSpreadDataImport
} from '@shared/components/excel/import-data/import-data-excel-setting.util';


// Common ------------------------------------------------------------------


/**
 * Modal xử các tác vụ liên quan đến Import Data bằng "File Excel" | "Google Sheets"
 *
 * @author admin
 * */
@Component({
  standalone: false,
  selector: 'app-import-data-excel-setting',
  templateUrl: 'import-data-excel-setting.component.html',
  styleUrls: [`import-data-excel-setting.scss`],
  providers: [CdkPortalOutlet]
})
export class ImportDataExcelSettingModalComponent extends ExcelDataAbstractService implements OnInit, OnDestroy, AfterViewInit {
  @Input() override options: IOptionsImportDataExcelSetting = {} as IOptionsImportDataExcelSetting;
  //@Input() override options!: IOptionsImportDataExcelSetting
  @Output() output$ = new EventEmitter<IConfigImportDataGoogleSheet>();

  @ViewChild('contentTemplate', {static: true}) contentTemplate!: TemplateRef<any>;
  @ViewChild('container', {read: ViewContainerRef}) private _viewContainerRef!: ViewContainerRef;

  isVisible: boolean = true;

  private compInstance$!: IImportDataHandlersAbstract;

  constructor(
    public importService: ImportExcelService,
    public appService: AppService,
    public userService: UserService,
    private componentFactoryResolver: ComponentFactoryResolver,
    private cdr: ChangeDetectorRef
  ) {
    super();
  }

  ngOnInit() {
    const tabRef = this.appForm.getParam('tabRef');
    this.navTabs = [
      {
        ref: 'excel',
        name: '',
        nameOriginal: 'Excel',
        icon: 'ph ph-file-xls',
        isActive: !tabRef || tabRef === 'excel'
      },
      {
        ref: 'googleSheets',
        name: '',
        nameOriginal: 'Google Sheets',
        icon: 'ph ph-file-spreadsheet',
        isActive: tabRef === 'googleSheets'
      }
    ]
    this.extendParamsAuth = {
      isOpenImportGG: 1,
    }

    this.importService.onInitImportData();
    this.importService.settingImportData.businessId = this.options.businessId;
    this.importService.settingImportData.urlApi = this.options.urlApi;
    setTimeout(() => {
      this.importService.settingImportData.tabRef = tabRef == 'googleSheets' ? 'googleSheets' : 'excel';
    })

    this.preOnLoadHandle((tokenId: number) => {
      this.importService.settingImportData.accessTokenId = tokenId;
    });
  }

  ngOnDestroy() {
    // if (typeof this.compInstance$.onHandlerClosedImportData === 'function') {
    // this.compInstance$.onHandlerClosedImportData()
    // }
    this.appForm.navService.removeParams([GOOGLE_SHEET_OPEN_MODAL_IMPORT])
    this.appForm.getDestroySubs()
  }

  ngAfterViewInit() {
    this.importService.contentTmpImportData = this.contentTemplate;
    this.createComponent();
  }

  createComponent() {
    if (!this._viewContainerRef) {
      return;
    }
    const factory = this.componentFactoryResolver.resolveComponentFactory(
      this.options.componentHandle
    );
    const componentRef = this._viewContainerRef.createComponent(factory)
    this.compInstance$ = componentRef.instance as IImportDataHandlersAbstract;

    this.cdr.detectChanges()
  }

  /**
   * Handle start import data -------------------------------------------------------------------------------------------------------
   * */

  /**
   *
   * */
  onImportData() {
    if (this.isValid()) {
      this.importService.settingImportData.isImportSubmit = true;
      if (this.importService.settingImportData.tabRef == 'excel') {
        return this.compInstance$.onHandlerSubmitImportData(this.importService.settingImportData);
      }

      this._preCheckSpreadData();
    }
  }

  private _preCheckSpreadData() {
    const rowHeaders = this._getRowHeaders();
    if (!this.importService.settingImportData.accessTokenId || !rowHeaders || !Object.keys(rowHeaders).length) {
      this.appForm.notifyWarning('common.messages.invalidData');
    } else {

      const params: IParamsCheckSpreadDataImport = {
        businessId: this.authService.businessCurrent?.id ?? 0,
        accessTokenId: this.importService.settingImportData.accessTokenId,
        spreadId: this.importService.settingImportData.spreadId,
        spreadUrl: this.importService.settingImportData.spreadUrl,
        spreadSheetId: this.importService.settingImportData.spreadSheetId,
        spreadSheetTitle: this.importService.settingImportData.spreadSheetTitle,
        rowHeaders: JSON.stringify(rowHeaders),
        pageSize: 200,
        originalHeader: this.options?.originalHeader ? 1 : 0
      }

      this.googleSheetService.checkSpreadDataImport(params).subscribe({
        next: (res: any) => {
          if (!res.code) {
            this.errors['spreadId'] = 'Link file Google Sheets không có data để tiến hành import';
            this.appForm.disabledSubmit = false
          } else {

            const data = res.data;
            this.importService.settingImportData.headersFinal = data.headersFinal;
            this.importService.settingImportData.progressPaginator.totalPages = data.totalPages;
            this.importService.settingImportData.progressPaginator.totalItems = data.totalItems;

            this.compInstance$.onHandlerSubmitImportData(this.importService.settingImportData)
          }
        }
      })
    }
  }

  private _getRowHeaders() {
    const headersMap = this.compInstance$.onDefineHeadersImportData();
    return Object.entries(headersMap).reduce((acc: { [key: string]: any }, [key, obj]) => {
      acc[this.appService.translate(key).toLowerCase()] = obj.key;
      return acc;
    }, {});
  }

  isValid() {
    this.errors = {};

    let isValid = true;
    if (typeof this.compInstance$.onHandlerValidateImportData === 'function') {
      isValid = this.compInstance$.onHandlerValidateImportData(this.importService.settingImportData);
    }
    if (!isValid) {
      return false;
    }

    const {tabRef, spreadSheetTitle, spreadUrl} = this.importService.settingImportData;
    if (tabRef == 'googleSheets') {
      if (!spreadUrl || this.errors['spreadId']) {
        this.errors['spreadId'] = 'Link file Google Sheets không hợp lệ';
        return false;
      }
      if (!spreadSheetTitle || this.errors['spreadSheetId']) {
        this.errors['spreadSheetId'] = 'Bạn chưa chọn sheet cần lấy dữ liệu';
        return false;
      }
    }
    return true;
  }


  /**
   * Handle API -------------------------------------------------------------------------------------------------------
   * */

  // Đổi tab excel
  override onChangeTab(tab: INavTabDataGird) {
    this.importService.settingImportData.tabRef = tab.ref as ITabRefExportDataSetting;
    this.isVisible = this.importService.settingImportData.tabRef === 'excel';
    super.onChangeTab(tab, (tokenId: number) => {
      this.importService.settingImportData.accessTokenId = tokenId;
    });
  }


  /**
   * ------------------------------------------------------------------------------------------------------------------
   * Handle on change -------------------------------------------------------------------------------------------------
   * ------------------------------------------------------------------------------------------------------------------
   * */

  // Chọn tài khoản kết nối
  onSelectedToken(tokenId: number) {
    this.importService.settingImportData.accessTokenId = tokenId;
  }

  // Thay đổi link file GGS
  override onChangeSpreadGGUrl(spreadUrl: string) {
    this.importService.settingImportData.spreadId = this.getGoogleSheetsSpreadId(spreadUrl) ?? '';
    if (!spreadUrl) {
      this._resetDataSpread();
    }

    super.onChangeSpreadGGUrl(
      spreadUrl,
      this.importService.settingImportData.accessTokenId
    )
  }

  // Chọn Sheet có sẵn
  onChangSheetId(sheetId: number) {
    this._resetDataSpread();
    this.importService.settingImportData.spreadSheetId = sheetId;

    const shs = this.sheetOptions.find(sh => sh.value == sheetId);
    this.importService.settingImportData.spreadSheetTitle = shs ? shs.label : '';
  }

  // Reset thông tin dữ liệu cần xử lý của file GGS
  private _resetDataSpread() {
    this.importService.settingImportData.progressPaginator.totalPages = 0
    this.importService.settingImportData.progressPaginator.totalItems = 0
  }
}


@Injectable({
  providedIn: 'root'
})
@Pipe({
  name: 'uriFileExcelExample',
  standalone: true,
})
export class UriFileExcelExamplePipe implements PipeTransform {
  constructor(
    private imgCdn: ImgCdnPipe,
    private transLoco: TranslocoService,
  ) {
  }

  /**
   * @param uriConst - Truyền link màn hình thao tác
   * @param useType - Loại file mẫu cần lấy
   * @param field - Thuộc tính muốn lấy trong const
   * */
  transform(uriConst: string, useType: 'excel' | 'ggs', field: 'name' | 'link' = 'name'): string {
    const findExp = EXCEL_URI_FILES_EXAMPLE[uriConst] ?? '';
    if (!uriConst || !findExp) {
      return '';
    }

    if (useType == 'excel') {
      if (field == 'link') {
        return this.imgCdn.transform(this.getLink(findExp.excel.links));
      }
      return findExp.excel.name;
    }

    return this.getLink(findExp.ggs.links);
  }

  private getLink(links: ExcelUriFilesExpLinks) {
    const code = this.transLoco.getActiveLang() as ILanguageCodes;

    return links[code] ?? '';
  }
}
